import { useRef, useState } from 'react';

export default function ProfileCard({
  profile = {},
  mode = 'dating',
  style,
  className = '',
  isTopCard = false,
  onSwipe = () => {},
  onDoubleTap = () => {},
}) {
  const {
    name = '',
    age = '',
    distance = '',
    bio = '',
    photos = [],
  } = profile;

  const cardRef = useRef(null);
  const [startX, setStartX] = useState(0);
  const [offsetX, setOffsetX] = useState(0);
  const [rotation, setRotation] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  const safePhotos = Array.isArray(photos) ? photos : [];
  const currentPhoto = safePhotos[0] ?? '';

  const lastTap = useRef(0);

  const handleTap = (e) => {
    if (!isTopCard || isDragging) return;
    const now = Date.now();
    if (now - lastTap.current < 300) {
      e.preventDefault();
      onDoubleTap();
    }
    lastTap.current = now;
  };

  const getX = (e) => e.clientX ?? e.touches?.[0]?.clientX ?? 0;

  const handlePointerDown = (e) => {
    if (!isTopCard) return;
    setIsDragging(true);
    setStartX(getX(e));
    cardRef.current.style.transition = 'none';
  };

  const handlePointerMove = (e) => {
    if (!isDragging) return;
    const diffX = getX(e) - startX;
    setOffsetX(diffX);
    setRotation(diffX * 0.08);
  };

  const handlePointerUp = (e) => {
    if (!isDragging) return;
    setIsDragging(false);

    const diffX = getX(e) - startX;
    cardRef.current.style.transition = 'transform 0.45s ease-out';

    if (Math.abs(diffX) > 120) {
      onSwipe(diffX > 0 ? 'right' : 'left');
      setOffsetX(diffX > 0 ? 1500 : -1500);
      setRotation(diffX > 0 ? 30 : -30);
    } else {
      setOffsetX(0);
      setRotation(0);
    }
  };

  return (
    <div
      ref={cardRef}
      className={`absolute inset-0 rounded-2xl overflow-hidden bg-white shadow-2xl ${className}`}
      style={{
        ...style,
        transform: `translateX(${offsetX}px) rotate(${rotation}deg)`,
      }}
      onPointerDown={handlePointerDown}
      onPointerMove={handlePointerMove}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerUp}
      onClick={handleTap}
    >
      <img
        src={currentPhoto}
        alt={name}
        className="w-full h-full object-cover pointer-events-none"
        draggable={false}
      />

      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black/60" />

      <div className="absolute bottom-6 left-5 right-5 text-white">
        <h2 className="text-3xl font-bold text-center text-yellow-200">
          {name}{mode === 'dating' && age && `, ${age}`}
        </h2>

        {mode === 'dating' && <p className="opacity-90 text-white text-center">{distance}</p>}
        {mode === 'networking' && <p>💼 Open to collab & coffee</p>}
        {mode === 'friends' && <p>🤝 Looking for vibe match</p>}
        {mode === 'activities' && <p>🍽️ Swipe to decide</p>}
        {mode === 'freelance' && <p>🛠️ Available for gigs</p>}

        <p className="mt-3 line-clamp-3 text-white text-center">{bio}</p>
      </div>
    </div>
  );
}
